(function(scope, undefined) {
  /**
   * A stupidly simple cookie storage class.
   *
   * @param {String} prefix
   * Cookie prefix.
   *
   * @param {String} separator
   * Prefix separator. (Defaults to '-')
   */
  function Storage(prefix, separator) {
    var prefixSeparator = typeof separator === "string" ? separator : "-";
    this.prefix = prefix + prefixSeparator;
  }

  var s = Storage.prototype;

  /**
   * Instance properties
   */

  s.prefix = ""; // Cookie prefix
  s.defaultLifetime = 2 * 60 * 60; // Default lifetime in seconds

  /**
   * Instance methods
   */

  /**
   * Sets a cookie.
   *
   * @param {String} key
   * Cookie name.
   *
   * @param {String} value
   * Cookie value.
   *
   * @param {Number} lifetime
   * Cookie lifetime in seconds.
   */
  s.set = function(key, value, lifetime) {
    if (typeof lifetime === "undefined") {
      lifetime = this.defaultLifetime;
    }

    var date = new Date();
    date.setTime(date.getTime() + lifetime * 1000);
    var expires = "; expires=" + date.toGMTString();

    document.cookie = this.prefix + key + "=" + value + expires + "; path=/";
  };

  /**
   * Gets a stored cookie value.
   *
   * @param  {String} key
   * Cookie name.
   *
   * @return {String}
   * The stored value.
   */
  s.get = function(key) {
    var nameEQ = this.prefix + key + "=",
      cookieArray = document.cookie.split(";"),
      itemCount = cookieArray.length,
      nameLength = nameEQ.length;

    for (var i = 0; i < itemCount; i++) {
      var cookie = cookieArray[i];

      while (cookie.charAt(0) == " ") {
        cookie = cookie.substring(1);
      }

      if (cookie.indexOf(nameEQ) == 0) {
        return cookie.substring(nameLength);
      }
    }

    return undefined;
  };

  /**
   * Deletes a cookie.
   *
   * @param  {String} key
   * Cookie name.
   */
  s.delete = function(key) {
    this.set(key, "", -1);
  };

  // Exports
  scope.CrisisMessageStorage = Storage;
})(this);
